export enum ExprKind {
  FUNCTION = "FUNCTION",
  FUNCTION_ARGUMENTS = "FUNCTION_ARGUMENTS",
  ARRAY = "ARRAY",
  METHOD_CALL = "METHOD_CALL",
  PARENTHESIS = "PARENTHESIS",
  NUM_DIVIDE = "NUM_DIVIDE",
  NUM_MULTIPLY = "NUM_MULTIPLY",
  NUM_PLUS = "NUM_PLUS",
  NUM_MINUS = "NUM_MINUS",
  NUM_POWER = "POWER",
  NUM_UNARY_MINUS = "UNARY_MINUS",
  NUM_LITERAL = "NUM_LITERAL",
  REF_ELEMENT = "REF_ELEMENT",
  REF_PROPERTY = "REF_PROPERTY",
  STR_CONCAT = "STR_CONCAT",
  STR_LITERAL = "STR_LITERAL",
  AND = "AND",
  OR = "OR",
  XOR = "XOR",
  NOT = "NOT",
  BOOLEAN_LITERAL = "BOOLEAN_LITERAL",
  LOGICAL_LITERAL = "LOGICAL_LITERAL",
  CMP_EQUALS = "CMP_EQUALS",
  CMP_NOT_EQUALS = "CMP_NOT_EQUALS",
  CMP_LESS_THAN = "CMP_LESS_THAN",
  CMP_LESS_THAN_OR_EQUAL = "CMP_LESS_THAN_OR_EQUAL",
  CMP_GREATER_THAN = "CMP_GREATER_THAN",
  CMP_GREATER_THAN_OR_EQUAL = "CMP_GREATER_THAN_OR_EQUAL",
  PARSE_ERROR = "PARSE_ERROR" /* to be used when no expr was compiled due to a parse/validation error */,
}
